// src/pages/AdminPanel.js
import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

const ROLES = ['user', 'manager', 'admin'];

export default function AdminPanel() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await api.get('/users');  // JWT via api.js
        setUsers(data);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleRoleChange = async (userId, newRole) => {
    setUpdatingId(userId);
    try {
      const updated = await api.patch(`/users/${userId}`, { role: newRole });
      setUsers(prev => prev.map(u => (u.id === userId ? updated : u)));
    } finally {
      setUpdatingId(null);
    }
  };

  if (loading) return <div className="p-6">Loading users...</div>;

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-2xl font-bold mb-4">User Management</h1>
      <table className="w-full text-left border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Name</th>
            <th className="p-2 border">Email</th>
            <th className="p-2 border">Role</th>
            <th className="p-2 border">Team</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id} className="border-t">
              <td className="p-2 border">{user.name || '—'}</td>
              <td className="p-2 border">{user.email}</td>
              <td className="p-2 border">
                <select
                  className="border rounded px-2 py-1"
                  value={user.role}
                  onChange={(e) => handleRoleChange(user.id, e.target.value)}
                  disabled={updatingId === user.id}
                >
                  {ROLES.map(role => (
                    <option key={role} value={role}>
                      {role.charAt(0).toUpperCase() + role.slice(1)}
                    </option>
                  ))}
                </select>
              </td>
              <td className="p-2 border">{user.team || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
